import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { useContactContext } from "@/contexts/contact";
import { useBrandContext } from "@/shared/contexts";
import { useI18n } from "@/contexts/i18n";
import { UserSignupIllustrationMobile, UserSignupIllustrationDesktop, } from "../UI";
import { useIsMobile } from "@/hooks";
import { useFormContext } from "react-hook-form";
export const LoginNudge = () => {
    const { t } = useI18n();
    const { urls } = useBrandContext();
    const isMobile = useIsMobile();
    const { userCookieData } = useContactContext();
    const { getValues } = useFormContext();
    const userData = userCookieData ? userCookieData : getValues();
    const handleLoginButtonPress = () => {
        const url = new URL(urls.oauth);
        url.searchParams.set("m", "classified_detail_lead_confirmation_login_nudge_account_login");
        url.searchParams.set("redirect_uri", window.location.href);
        window.location.href = url.toString();
    };
    return (_jsxs(Box, { width: "100%", display: "flex", flexDirection: "column", alignItems: {
            "breakpoint.base": "flex-start",
            "breakpoint.sm": "center",
        }, gap: "spacing.24", marginBottom: "spacing.24", children: [_jsx(Box, { maxWidth: {
                    "breakpoint.base": "100%",
                    "breakpoint.lg": "568px",
                }, typography: "typography.headline.24.bold", children: t("contact.form.login_box.title") }), _jsxs(Box, { minWidth: {
                    "breakpoint.base": "100%",
                    "breakpoint.lg": "568px",
                }, position: "relative", display: "flex", flexDirection: "column", padding: "spacing.16", gap: "spacing.16", borderRadius: "radius.16", borderWidth: "borderWidth.1", borderColor: "color.border.transparent.default", borderStyle: "solid", children: [_jsxs(Box, { display: "flex", justifyContent: "space-between", width: "100%", children: [_jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.4", children: [_jsxs(Box, { minHeight: "24px", verticalAlign: "middle", typography: "typography.body.16.bold", children: [userData === null || userData === void 0 ? void 0 : userData.firstName, " ", userData === null || userData === void 0 ? void 0 : userData.lastName] }), _jsx(Box, { minHeight: "18px", verticalAlign: "middle", typography: "typography.body.14.regular", children: userData === null || userData === void 0 ? void 0 : userData.email }), _jsx(Box, { minHeight: "20px", verticalAlign: "middle", typography: "typography.body.14.regular", children: userData === null || userData === void 0 ? void 0 : userData.phoneNumber })] }), _jsx(Box, { position: {
                                    "breakpoint.base": "relative",
                                    "breakpoint.sm": "absolute",
                                }, right: "0", top: {
                                    "breakpoint.base": "0px",
                                    "breakpoint.sm": "13px",
                                }, children: isMobile ? (_jsx(UserSignupIllustrationMobile, {})) : (_jsx(UserSignupIllustrationDesktop, {})) })] }), _jsx(Box, { display: "flex", justifyContent: "space-between", width: {
                            "breakpoint.base": "100%",
                            "breakpoint.sm": "50%",
                        }, children: _jsx(Button, { isFullWidth: {
                                "breakpoint.base": true,
                                "breakpoint.sm": false,
                            }, variant: "secondary", onPress: handleLoginButtonPress, children: t("contact.form.login_box.button_text") }) })] })] }));
};
